import type React from "react";

const registry = new Map<string, React.ReactNode>();

export const choiceIconRegistry = {
  register(key: string, icon: React.ReactNode) {
    registry.set(key, icon);
  },
  get(key: string): React.ReactNode | undefined {
    return registry.get(key);
  },
  has(key: string): boolean {
    return registry.has(key);
  },
};
